import Typography from "@portal/components/atoms/v2/typography";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { MainBox } from "../components/mainBox";
import { StartPageInfo } from "./components";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { UserMessageComponent } from "../components/message/UserMessageComponent";
import { ClearReduxData } from "../components/helpers";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Spinner from "@portal/components/atoms/v2/spinner";
import Button from "@portal/components/atoms/v2/buttons/button";
import { OnFooterClick } from "./handlers/OnFooterClick";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { setSavingsAgreementStartDate } from "@portal/redux/reducers/ui/createSavingsAgreement";
import { format } from "date-fns";
import Icon from "@portal/components/atoms/icons";
import { useSession } from "@portal/auth/client/SessionProvider";
import RobotHeaderText from "../components/robotHeaderText";

export const StartPage = ({ centerId, isDefaultLanguage }: IPageProps) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { session } = useSession();
  const [showUserMessage, setShowUserMessage] = useState(false);
  // TODO TMP FJERNET const [isToggleBoxOpen, setIsToggleBoxOpen] = useState(false);
  const returningUser = useAppSelector(state => state.persisted.riskLevel.returningUser);
  const savingProposalRequest = useAppSelector(state => state.persisted.savingProposal);

  const isLoggedIn = session?.status === "authenticated";
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  // Clear redux data if the user is different than the cached user
  useEffect(() => {
    if (isLoggedIn && returningUser) {
      const existingCustomerNumber = savingProposalRequest?.customerNumber;
      if (existingCustomerNumber !== "" && session?.user.id !== existingCustomerNumber) {
        ClearReduxData(dispatch);
      }
    }
  }, [dispatch, savingProposalRequest, isLoggedIn, returningUser, session?.user, session]);

  // Ask returning user to keep or delete cached data
  useEffect(() => {
    if (returningUser) setShowUserMessage(true);
  }, [returningUser]);

  return (
    <>
      {showUserMessage && (
        <UserMessageComponent
          userMessage={texts.VALIDATION_RETURNING}
          showDialog={showUserMessage}
          primaryButtonText={texts.MESSAGE_RESTART}
          primaryButtonClick={() => {
            setShowUserMessage(false);
            ClearReduxData(dispatch);
            router.push(`/robot?centerId=${centerId}`);
          }}
          secondaryButtonText={texts.MESSAGE_CONTINUE}
          secondaryButtonClick={() => {
            dispatch(setSavingsAgreementStartDate(format(new Date(), "yyyy-MM-dd")));
            setShowUserMessage(false);
          }}
        />
      )}
      <MainBox>
        <RobotHeaderText text={texts.PAGE_0_HEADER} />
        <TextLine wide />
        <div className="space-y-3">
          <Typography variant="Body">{texts.PAGE_0_SUBHEADER}</Typography>
          <div className="flex items-center">
            <Typography variant="Body">
              {texts.PAGE_0_SUBHEADER_2}
              <Link
                className="text-blueHighlighted"
                target="_blank"
                href={"/informasjon-til-kunder-vedrorende-ansvar-v1.pdf"}
                prefetch={false}
              >
                her
              </Link>
            </Typography>
            <Icon name="finautIcon" size="xxxlarge" />
          </div>
          {session?.status === "loading" && (
            <div className="flex mt-5">
              <Spinner />
            </div>
          )}
          {/* TODO TMP FJERNET <div className="flex justify-center">
            <ToggleButton
              activeText={texts.PAGE_0_BUTTON_TEXT_ACTIVE}
              inActiveText={texts.TEXT_CLOSE}
              expanded={isToggleBoxOpen}
              setExpanded={setIsToggleBoxOpen}
            />
          </div> */}
          {/* TODO TMP FJERNET {isToggleBoxOpen && */} <StartPageInfo isDefaultLanguage={isDefaultLanguage} />
        </div>
      </MainBox>
      <div className="flex w-full p-5 justify-center">
        <Button
          onClick={() => OnFooterClick(centerId)}
          text={texts.BUTTON_START_SAVING}
          disabled={session?.status === "loading"}
          wide
          primary
        />
      </div>
    </>
  );
};
